module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append("<div id=\"dialog\" title=\"Quick Paste\">\r\n    <p>Paste your content in the following text field using the keyboard (Ctrl+V)</p>\r\n    <textarea name=\"pastedText\" id=\"pastedText\" cols=\"30\" rows=\"10\" placeholder=\"caption1,value1&#10;caption2,value2&#10;captionAndValue3\">")
    ; __append(escapeFn( pastedText ))
    ; __append("</textarea>\r\n</div>")
  }
  return __output;

}